<template>
    <div>
        <vs-table ref="table" pagination :max-items="4" search :data="taskTransports">

            <template slot="thead">
                <vs-th sort-key="user">{{$t("User")}}</vs-th>
                <vs-th sort-key="distance">{{$t("Distance")}}</vs-th>
                <vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
                <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                <vs-th sort-key="start_point">{{$t("StartPoint")}}</vs-th>
                <vs-th sort-key="end_point">{{$t("EndPoint")}}</vs-th>
                <vs-th sort-key="vehicle">{{$t("Vehicle")}}</vs-th>
                <vs-th sort-key="transport_type">{{$t("TransportType")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].user_id">
                            {{ users[data[index].user_id].name }}
                        </vs-td>

                        <vs-td :data="data[index].end_kilometers - data[index].start_kilometers">
                            {{ data[index].end_kilometers - data[index].start_kilometers }}
                        </vs-td>

                        <vs-td :data="data[index].start_time">
                            {{ moment(data[index].start_time).format('DD/MM/YYYY HH:mm') }}
                        </vs-td>

                        <vs-td :data="data[index].end_time">
                            {{ moment(data[index].end_time).format('DD/MM/YYYY HH:mm') }}
                        </vs-td>

                        <vs-td :data="data[index].start_point">
                            {{ data[index].start_point }}
                        </vs-td>

                        <vs-td :data="data[index].end_point">
                            {{ data[index].end_point }}
                        </vs-td>

                        <vs-td :data="vehicleMap[data[index].vehicle_id]">
                            {{ vehicleMap[data[index].vehicle_id].name }}
                        </vs-td>

                        <vs-td :data="transportTypeMap[data[index].transport_type_id]">
                            {{ transportTypeMap[data[index].transport_type_id].name }}
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Edit')" :active.sync="activeNotesPrompt" style="z-index: 54000">
            <div>
                <span>{{$t("Notes")}}</span>
                <vs-textarea v-model="notesEditArea" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveNotes">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr
        },
        props: {
            taskId: {
                type: Number,
                required: true
            },
            users: {
                type: Object,
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            },
        },
        data() {
            return {
                transportTypes: [],
                vehicles: [],
                taskTransports: [],
                notesEditArea: '',
                activeNotesPrompt:false,
            }
        },
        methods: {
            updateTransports() {
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/transport")
                    .then(function (response) {
                        thisIns.taskTransports = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            saveNotes(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/transport/" + this.selected.id + "/notes", {
                    notes: thisIns.notesEditArea
                }).then(function () {
                    thisIns.updateTransports();
                    thisIns.selected = {};
                    thisIns.activeNotesPrompt = false
                }).catch(function (error) {
                    thisIns.activeNotesPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        computed: {
            transportTypeMap: function () {

                let types = {};
                for(let x = 0; x < this.transportTypes.length; x++){
                    types[this.transportTypes[x].id] = this.transportTypes[x];
                }
                return types

            },
            vehicleMap: function () {
                let types = {};
                for(let x = 0; x < this.vehicles.length; x++){
                    types[this.vehicles[x].id] = this.vehicles[x];
                }
                return types
            }
        },
        watch:{
            taskId: function () {
                this.updateTransports();
            }
        },
        created() {

            const thisIns = this;

            this.$http.get('/api/v1/transport_type/')
                .then(function (response) {
                    thisIns.transportTypes = response.data;
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            this.$http.get('/api/v1/vehicle/?type=names')
                .then(function (response) {
                    thisIns.vehicles = response.data;

                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            thisIns.updateTransports();

        }

    }
</script>
